/**
 * @generated SignedSource<<aa2a7f8ef9a73070ee30c8246e9f2eb1>>
 * @relayHash 101091777b76af9e6507cf9e62efc239
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6b10eab7552e38172027bfb78f14430cdea2fca602d9918b19ce0af182bca43e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type useTeamDataBulkFetchQuery$variables = {
  siteId: string;
  teamIds: ReadonlyArray<string>;
};
export type useTeamDataBulkFetchQuery$data = {
  readonly team: {
    readonly teamsV2: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly id: string;
      readonly largeAvatarImageUrl: string | null | undefined;
      readonly type: {
        readonly name: string;
        readonly verified: boolean | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type useTeamDataBulkFetchQuery = {
  response: useTeamDataBulkFetchQuery$data;
  variables: useTeamDataBulkFetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "teamIds"
},
v2 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "teamIds"
  },
  {
    "kind": "Variable",
    "name": "siteId",
    "variableName": "siteId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "name"
},
v4 = {
  "kind": "ScalarField",
  "name": "verified"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "kind": "ScalarField",
  "name": "description"
},
v8 = {
  "kind": "ScalarField",
  "name": "largeAvatarImageUrl"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useTeamDataBulkFetchQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "TeamV2",
            "kind": "LinkedField",
            "name": "teamsV2",
            "plural": true,
            "selections": [
              {
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "type",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useTeamDataBulkFetchQuery",
    "selections": [
      {
        "concreteType": "TeamQuery",
        "kind": "LinkedField",
        "name": "team",
        "plural": false,
        "selections": [
          {
            "args": (v2/*: any*/),
            "concreteType": "TeamV2",
            "kind": "LinkedField",
            "name": "teamsV2",
            "plural": true,
            "selections": [
              {
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "type",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ]
              },
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "101091777b76af9e6507cf9e62efc239",
    "id": "6b10eab7552e38172027bfb78f14430cdea2fca602d9918b19ce0af182bca43e",
    "metadata": {},
    "name": "useTeamDataBulkFetchQuery",
    "operationKind": "query",
    "text": "query useTeamDataBulkFetchQuery($teamIds:[ID!]!,$siteId:String!){team{teamsV2(ids:$teamIds,siteId:$siteId)@optIn(to:\"Team\"){type{name,verified,id},id,displayName,description,largeAvatarImageUrl}}}"
  }
};
})();

(node as any).hash = "fb4c7d2afe156af18991be9b551e89df";

export default node;
